define((require, exports, module) => {
    'use strict';

    /**
     * @constructor
     * @param {Object} params
     * @param {number} size – размер файла (в байтах).
     * @param {number} speed – скорость загрузки (килобайт в секунду).
     * @param {number} progress – прогресс загрузки файла (в процентах).
     * @param {number} attempt – номер попытки загрузки файла.
     * @param {number} status – xhr.status
     * @param {string} responseText – xhr.responseText
     * @param {UploadReason|Error|null} error
     */
    function UploaderData(params) {
        this.size = params.size || 0;
        this.speed = params.speed || 0;
        this.progress = params.progress || 0;
        this.attempt = params.attempt || 0;
        this.status = params.status || 0;
        this.responseText = params.responseText || '';
        this.error = params.error || null;
    }

    module.exports = UploaderData;
});
